import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IConfig, NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { AppMaterialModule } from '@app/app-material.module';
import { ComponentsModule } from '@shared/components/components.module';
import { AnimationsModule } from '@shared/animations/animations.module';
import { CondutoresComponent } from '@modules/condutores/pages/condutores/condutores.component';
import { CondutorController } from '@modules/condutores/controllers';
import { FormularioCondutorComponent } from '@modules/condutores/components/formulario-condutor/formulario-condutor.component';

const maskConfig: Partial<IConfig> = {
  validation: false,
};

@NgModule({
  declarations: [CondutoresComponent, FormularioCondutorComponent],
  imports: [
    RouterModule,
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    AppMaterialModule,
    ComponentsModule,
    NgxMaskDirective,
    NgxMaskPipe,
    AnimationsModule,
  ],
  providers: [provideNgxMask(maskConfig), CondutorController],
})
export class CondutoresModule {}
